import React from 'react';
import injectSheet from 'react-jss'
import NewsletterForm from "./NewsletterForm"

export const styles = (theme) => (
{
    root: {
      maxWidth: 640,
      margin: 'auto',
      [theme.breakpoint('tablet')]: {
        display: 'flex'
      }
    },
    fields: {
      display: 'flex',
      flex: '1 1 100%',
      marginBottom: '2rem',
      minHeight: 40,
      position: 'relative',
      [theme.breakpoint('tablet')]: {
        marginRight: 32,
        marginBottom: 0
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        height: 1,
        left: 0,
        right: 0,
        backgroundColor: theme.colors.faintGrey
      }
    },
    gender: {
      minWidth: 80,
      marginRight: 12,
      [theme.breakpoint("tablet")]: {
        marginRight: 18
      }
    },
    formFieldRow: {
        display: 'flex',
        position: "relative",
        alignItems: 'center',
        "& div:last-child": {
          flexGrow: 1
        }
    },
    formFont: {
        ...theme.font.fieldLabel,
        fontFamily: theme.font.family,
        fontSize: theme.getRemValue(14),
        lineHeight: 1.2,
        [theme.breakpoint("tablet")]: {
            fontSize: theme.getRemValue(16),
            lineHeight: 2
        }
    },
    formField: {
        marginLeft: 10,
        borderRadius: 0
    },
    input: {
        border: 'none',
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        outline: 'none',
        lineHeight: 1.2,
        width: '100%',
        [theme.breakpoint("mobile")]: {
          width: 'calc(100% - 10px)',
        },
        "&::-webkit-input-placeholder": {
          color: theme.colors.subTitle
        },
        "&::-ms-input-placeholder": {
          color: theme.colors.subTitle
        },
        "&::-moz-placeholder": {
          color: theme.colors.subTitle
        }
    },
    dropDownContainer: {
      ...theme.font.familyBoldStyle,
      marginLeft: 0,
    },
    dropDown: {
        top: "100%",
        ...theme.card.styles,
        border: 'solid 1px #ececec',
        textAlign: 'left',
        '& a': {
          color: theme.colors.black,
          '&:hover': {
            textDecoration: 'none'
          }
        }
    },
    submitButton: {
        cursor: "pointer"
    },
    error: {
      color: 'red',
      position: 'absolute',
      fontSize: 10,
      margin: [0, 0, 0, 10],
      top: '100%',
      bottom: 'auto',
      [theme.breakpoint("tablet")]: {
        margin: [4, 0, 0, 10],
        fontSize: '0.8em',
      }
    },
    actions: {
      display: 'inline-block',
      textAlign: 'center',
      [theme.breakpoint("tablet")]: {
          textAlign: 'inherit'
      }
    },
    link: {
      minHeight: 40,
      borderColor: theme.colors.faintGrey,
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.getRemValue(12),
      padding: [15, 34, 13, 34],
      letterSpacing: '0.3px',
      lineHeight: 1,
      borderRadius: '2px',
      transition: `background-color 0.2s ${theme.animation.easing.accelerationCurve}`,
      '&:hover': {
        color: theme.colors.white,
        backgroundColor: theme.colors.lightBlue,
        borderColor: theme.colors.lightBlue
      }
    }
});

const NewsletterFormPageStyle = injectSheet(styles)(({ classes, classNames, ...rest }) => (
    <NewsletterForm classes={classes} classNames={classNames} {...rest} />
))

export default NewsletterFormPageStyle;



// WEBPACK FOOTER //
// ./src/components/Newsletter/NewsletterFormPageStyle.js